/** Inline stroke icons (24×24 grid, currentColor) — no icon font or library. Decorative by default. */
const PATHS = {
  dashboard: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
  tickets: 'M8 6h13 M8 12h13 M8 18h13 M3.5 6h.01 M3.5 12h.01 M3.5 18h.01',
  plus: 'M12 5v14 M5 12h14',
  reports: 'M3 3v18h18 M7 16v-5 M12 16V8 M17 16v-9',
  bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 0 1-3.46 0',
  admin: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4',
  settings: 'M4 21v-7 M4 10V3 M12 21v-9 M12 8V3 M20 21v-5 M20 12V3 M1 14h6 M9 8h6 M17 16h6',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M12 2v2 M12 20v2 M4.93 4.93l1.41 1.41 M17.66 17.66l1.41 1.41 M2 12h2 M20 12h2 M6.34 17.66l-1.41 1.41 M19.07 4.93l-1.41 1.41',
  moon: 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z',
  system: 'M3 4h18v12H3z M8 20h8 M12 16v4',
  language: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M2 12h20 M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z',
  menu: 'M3 6h18 M3 12h18 M3 18h18',
  collapse: 'M15 18l-6-6 6-6',
  expand: 'M9 18l6-6-6-6',
  close: 'M18 6L6 18 M6 6l12 12',
  chevronDown: 'M6 9l6 6 6-6',
  check: 'M20 6L9 17l-5-5',
  // Priority
  prioCritical: 'M7 11l5-5 5 5 M7 18l5-5 5 5',
  prioHigh: 'M6 15l6-6 6 6',
  prioMedium: 'M5 9h14 M5 15h14',
  prioLow: 'M6 9l6 6 6-6',
  // Severity
  sevBlocker: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M4.93 4.93l14.14 14.14',
  sevCritical: 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z M12 9v4 M12 17h.01',
  sevMajor: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 8v4 M12 16h.01',
  sevMinor: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
  sevCosmetic: 'M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z M19 17l.7 1.3L21 19l-1.3.7L19 21l-.7-1.3L17 19l1.3-.7z',
  // Category
  tag: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z M7 7h.01',
  none: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M8 12h8',
  // Browsers (simplified generic glyphs, not brand logos)
  chrome: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M21.17 8H12 M3.95 6.06L8.54 14 M10.88 21.94L15.46 14',
  safari: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36z',
  edge: 'M21 13.5A9 9 0 1 1 18.4 5.6 M21 13.5c0-3.6-2.9-5.5-6-5.5-3.3 0-5.5 2.2-5.5 4.6 0 2.3 2 4.1 4.9 4.1 2 0 3.8-.8 5.1-2',
  firefox: 'M12 22a9 9 0 0 1-9-9c0-3.2 1.5-5.8 3.4-7.4-.2 2.1.8 3.6 2.1 4.2.1-3.3 2-6.3 5.1-7.8-.6 2.3.4 4.4 2.3 5.8A8.9 8.9 0 0 1 21 13a9 9 0 0 1-9 9z',
  globe: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M2 12h20 M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z',
  palette: 'M12 22a10 10 0 1 1 10-10c0 2.2-1.8 3-4 3h-1.5a1.5 1.5 0 0 0-1 2.6c.6.6.5 1.6-.2 2.1-.9.8-2.1 1.3-3.3 1.3z M7.5 10.5h.01 M10.5 7h.01 M15 7.5h.01',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, label }: { name: IconName; size?: number; label?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon"
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true, focusable: false })}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
